import { useRoutes } from 'react-router-dom';

// routes
import config from 'config';
import NotAuthorized from 'views/pages/NotAuthorized';
import NotFound from 'views/pages/NotFound';
import Welcome from 'views/pages/Welcome';
import AccountingRoutes from './AccountingRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import MainRoutes from './MainRoutes';
import ProcumentRoutes from './ProcumentRoutes';
import RoadsRoutes from './RoadsRoutes';
import QsRoutes from './QsRoutes';
import ArchitectureRoutes from './ArchitetureRoutes'

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes(
        [
            AuthenticationRoutes,
            MainRoutes,
            RoadsRoutes,
            AccountingRoutes,
            ProcumentRoutes,
            QsRoutes,
            ArchitectureRoutes,
            {
                path: '/welcome',
                element: <Welcome />
            },
            {
                path: '/unauthorized/action',
                element: <NotAuthorized />
            },
            {
                path: '*',
                element: <NotFound />
            }
        ],
        config.basename
    );
}
